export default defineNuxtRouteMiddleware(() => {
  if (process.env.NODE_ENV !== "development") {
    return navigateTo("/"); // Redirige vers la home (ou autre) si pas en dev
  }
});
